var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"flex flex-1"},[_c('Editor',{staticClass:"flex-1"}),_c('Preview',{staticClass:"w-1/3 border-l"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }